const waveSliderSection = document.querySelector(".wave-slider");

if (waveSliderSection) {
  const slider = tns({
    container: ".wave-transition-slider",
    items: 1,
    slideBy: "page",
    autoplay: false,
    nav: true,
    navContainer: document.querySelector(".wave-slider-title"),
    loop: false,
    controls: true,
    speed: 1000,
    prevButton: document.querySelector("#wave-data-controls .tns-prev"),
    nextButton: document.querySelector("#wave-data-controls .tns-next"),
  });

  const ellipses = document.querySelectorAll("#data-wave ellipse");
  const paragraphs = document.querySelectorAll(".paragraph-slide");

  function animateEllipsesTo(radius) {
    ellipses.forEach((el) => {
      el.setAttribute("ry", radius);
    });
  }

  function restoreOriginalRadii() {
    ellipses.forEach((el) => {
      const originalRy = el.getAttribute("data-radius-y");
      if (originalRy) el.setAttribute("ry", originalRy);
    });
  }

  function showParagraph(index) {
    paragraphs.forEach((p, i) => {
      if (parseInt(p.dataset.paragraphIndex) === index) {
        p.classList.remove("hidden", "opacity-0");
        p.classList.add("opacity-100");
      } else {
        p.classList.remove("opacity-100");
        p.classList.add("opacity-0");
        // setTimeout(() => p.classList.add(""), 700);
      }
    });
  }

  showParagraph(0);

  slider.events.on("transitionStart", () => {
    animateEllipsesTo(25);
    paragraphs.forEach((p) => {
      p.classList.remove("opacity-100");
      p.classList.add("opacity-0");
    });
  });

  slider.events.on("transitionEnd", (info) => {
    const index = info.displayIndex - 1;
    restoreOriginalRadii();
    showParagraph(index);
  });
}
